<template>
  <!-- TODO: Доделать уведомления на пунктах -->
  <div class="sidebar">
    <ul class="nav-list">
      <li>
        <router-link to="/dashboard">
          <i class="bx bx-grid-alt"></i>
          <span class="links_name">Главная</span>
        </router-link>
        <span class="tooltip">Главная</span>
      </li>
      <li>
        <router-link to="/reports">
          <i class="bx bx-pie-chart-alt-2"></i>
          <span class="links_name">Аналитика</span>
        </router-link>
        <span class="tooltip">Аналитика</span>
        <b-collapse v-model="visible">
          <ul class="child-block">
            <li class="child_item" v-if="canSeeOrderFinanceReport">
              <router-link to="/reports/order-finance"
                >Фин показатели заказов</router-link
              >
            </li>
            <li class="child_item" v-if="allAdministrators || allHeadsOfManagment">
              <router-link to="/reports/sales-analytic"
                >Аналитика продаж</router-link
              >
            </li>
            <li class="child_item" v-if="allAdministrators || allHeadsOfManagment || canSeeQuotationTO">
              <router-link to="/reports/client-portfolio"
                >Клиентский портфель</router-link
              >
            </li>
            <li class="child_item" v-if="allAdministrators">
              <router-link to="/reports/competitors"
                >Анализ рынка</router-link
              >
            </li>
            <li class="child_item" v-if="canSeeQuotationLogistics">
              <router-link to="/reports/order-service-activity"
                >Активность по логистике</router-link
              >
            </li>
            <li class="child_item" v-if="canSeeQuotationTO">
              <router-link to="/reports/order-to-activity"
                >Активность по ТО</router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/reports/order-analytic"
                >Аналитика поставок</router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/reports/quotation-rates"
                >Ставки по поставкам</router-link
              >
            </li>
            <li class="child_item" v-if="allAdministrators">
              <router-link to="/reports/department-efficiency"
                >Эффективность отделов</router-link
              >
            </li>
            <li class="child_item" v-if="allAdministrators || allHeadsOfManagment">
              <router-link to="/reports/order-scores"
                >Клиентские оценки</router-link>
            </li>
            <li class="child_item" v-if="allAdministrators || allHeadsOfManagment">
                <router-link to="/reports/order-delivery-quotation"
                  >Запросы поставщикам</router-link
                >
            </li>
            <li class="child_item" v-if="allAdministrators">
                <router-link to="/reports/finance-analytic"
                    >Доходы-расходы B2C</router-link
                >
            </li>
          </ul>
        </b-collapse>
      </li>
      <li v-if="canSeeQuotationTO">
        <router-link
          exact
          :to="{ path: '/order-kanban', query: { kanban_type: 'TO' } }"
        >
          <i class="bx bx-task"></i>
          <span class="links_name">Котировки ТО</span>
        </router-link>
      </li>
      <li v-if="canSeeQuotationLogistics">
        <router-link
          exact
          :to="{ path: '/order-kanban', query: { kanban_type: 'logistics' } }"
        >
          <i class="bx bx-task"></i>
          <span class="links_name">Котировки ТЭО</span>
        </router-link>
      </li>
      <li v-if="canSeeRequests">
        <router-link
          exact
          :to="{ path: '/order-kanban', query: { kanban_type: 'sales' } }"
        >
          <i class="bx bx-task"></i>
          <span class="links_name">Заявки</span>
        </router-link>
        <b-collapse v-model="visible">
          <ul class="child-block">
            <li class="child_item">
              <router-link to="/order-kanban/table/539"
                >Запросы / Лиды</router-link
              >
              <router-link to="/order-kanban/table/540"
                >Контакт с клиентом</router-link
              >
              <router-link to="/order-kanban/table/541"
                >Получение котировки</router-link
              >
              <router-link to="/order-kanban/table/542"
                >Котировка получена</router-link
              >
              <router-link to="/order-kanban/table/543"
                >КП направлено</router-link
              >
              <router-link to="/order-kanban/table/544"
                >Договор на подписании</router-link
              >
              <router-link to="/order-kanban/table/545"
                >Передача в поставку</router-link
              >
              <router-link to="/order-kanban/table/362">Отказ</router-link>
            </li>
          </ul>
        </b-collapse>
      </li>
      <li v-if="canSeeOrders">
        <router-link to="/orders">
          <i class="bx bx-shopping-bag"></i>
          <span class="links_name">Заказы</span>
        </router-link>
        <span class="tooltip">Заказы</span>
        <b-collapse id="collapse-4" v-model="visible" v-if="canSeeServices">
          <ul class="child-block">
            <li class="child_item">
              <router-link to="/orders/services/22"
                >Таможенное оформление
                <b-badge
                  class="badge-light"
                  pill
                  variant="danger"
                  v-if="notificationsLocal.to.length > 0"
                  >{{ notificationsLocal.to.length }}</b-badge
                ></router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/orders/services/logistics"
                >Логистика
                <b-badge
                  class="badge-light"
                  pill
                  variant="danger"
                  v-if="notificationsLocal.teo.length > 0"
                  >{{ notificationsLocal.teo.length }}</b-badge
                ></router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/orders/services/24"
                >Сертификация
                <b-badge
                  class="badge-light"
                  pill
                  variant="danger"
                  v-if="notificationsLocal.sertifikaciya.length > 0"
                  >{{ notificationsLocal.sertifikaciya.length }}</b-badge
                ></router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/orders/services/25"
                >Консалтинг и<br />сопутствующие<br />услуги
                <b-badge
                  class="badge-light"
                  pill
                  variant="danger"
                  v-if="notificationsLocal.other.length > 0"
                  >{{ notificationsLocal.other.length }}</b-badge
                ></router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/orders/services/75"
                >ПНК
                <b-badge
                  class="badge-light"
                  pill
                  variant="danger"
                  v-if="notificationsLocal.other.length > 0"
                  >{{ notificationsLocal.other.length }}</b-badge
                ></router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/orders/services/76"
                >СВХ
                <b-badge
                  class="badge-light"
                  pill
                  variant="danger"
                  v-if="notificationsLocal.other.length > 0"
                  >{{ notificationsLocal.other.length }}</b-badge
                ></router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/orders/services/77"
                >Страхование
                <b-badge
                  class="badge-light"
                  pill
                  variant="danger"
                  v-if="notificationsLocal.other.length > 0"
                  >{{ notificationsLocal.other.length }}</b-badge
                ></router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/orders/services/23"
                style="color: #bfbfbf;"
                >Архив Логистики
                <b-badge
                  class="badge-light"
                  pill
                  variant="danger"
                  v-if="notificationsLocal.teo.length > 0"
                  >{{ notificationsLocal.teo.length }}</b-badge
                ></router-link
              >
            </li>
          </ul>
        </b-collapse>
      </li>
      <li v-if="canSeeLogistic" style="display: none">
        <router-link to="/orders/services/23">
          <i class="bx bxs-truck"></i>
          <span class="links_name">Логистика</span>
        </router-link>
        <span class="tooltip">Логистика</span>
        <b-collapse id="collapse-4" v-model="visible" v-if="canSeeServices">
          <ul class="child-block">
            <li class="child_item">
              <router-link to="/trucks">Транспорт</router-link>
            </li>
            <li class="child_item">
              <router-link to="/drivers">Водители</router-link>
            </li>
          </ul>
        </b-collapse>
      </li>
      <li>
        <router-link to="/finance" v-if="canSeeFinance">
          <i class="bx bx-dollar-circle"></i>
          <span class="links_name">Финансы</span>
        </router-link>
        <span class="tooltip">Финансы</span>
        <b-collapse id="collapse-4" v-model="visible" v-if="canSeeFinance">
          <ul class="child-block">
            <li class="child_item">
              <router-link to="/finance/by-invoice-type/incoming"
                >Покупатель</router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/finance/by-invoice-type/outgoing"
                >Поставщик</router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/finance/vat-zero-export">Выгрузка НДС 0</router-link>
            </li>
          </ul>
        </b-collapse>
      </li>

      <li v-if="specialBuhgalters">
        <router-link to="/budget-2026">
          <i class="bx bx-money"></i>
          <span class="links_name">Бюджет 2026</span>
        </router-link>
        <span class="tooltip">Бюджет 2026</span>
        <b-collapse id="collapse-budget2026" v-model="visible" v-if="specialBuhgalters">
          <ul class="child-block">
            <li class="child_item">
              <router-link to="/budget-2026">Бюджет 2026</router-link>
            </li>
            <li class="child_item">
              <router-link to="/budget-2026/dictionary">Словарь таблицы</router-link>
            </li>
            <li class="child_item">
              <router-link to="/budget-2026/onec-dictionary">Словарь 1С</router-link>
            </li>
          </ul>
        </b-collapse>
      </li>
      <li v-if="specialBuhgalters">
        <router-link to="/budget">
          <i class="bx bx-money"></i>
          <span class="links_name">Бюджет</span>
        </router-link>
        <span class="tooltip">Бюджет</span>
        <b-collapse id="collapse-4" v-model="visible" v-if="specialBuhgalters">
          <ul class="child-block">
            <li class="child_item">
              <router-link to="/budget"
                >Бюджет</router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/budget/dictionary"
                >Словарь</router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/budget/onec-dictionary"
                >Словарь 1С</router-link
              >
            </li>
          </ul>
        </b-collapse>
      </li>
      <li>
        <router-link to="/finance/requests" v-if="canSeeFinance">
          <i class="bx bx-user-voice"></i>
          <span class="links_name">Запросы</span>
        </router-link>
        <span class="tooltip">Запросы</span>
        <b-collapse
          id="collapse-4"
          v-model="visible"
          v-if="isOnlyForAccountant"
        >
          <ul class="child-block">
            <li class="child_item" v-for="user in internalUsers" :key="user.id">
              <router-link :to="`/finance/requests/${user.id}`">
                {{ user.name }}
                <b-badge
                  class="badge-icon badge-light ml-1"
                  pill
                  variant="danger"
                  v-if="
                    notificationsLocal.by_creators[user.id] &&
                    notificationsLocal.by_creators[user.id].length > 0
                  "
                  >{{ notificationsLocal.by_creators[user.id].length }}</b-badge
                >
              </router-link>
            </li>
            <li class="child_item" v-if="agents.length > 0">
              <router-link to="/finance/requests/agents">
                Агенты
                <b-badge
                  class="badge-icon badge-light ml-1"
                  pill
                  variant="danger"
                  v-if="notificationsLocal.agents && notificationsLocal.agents.length > 0"
                  >{{ notificationsLocal.agents.length }}</b-badge
                >
              </router-link>
            </li>
          </ul>
        </b-collapse>
      </li>
      <li>
        <router-link to="/finance/payments" v-if="isOnlyForAccountant">
          <i class="bx bx-credit-card-front"></i>
          <span class="links_name">Платежи</span>
        </router-link>
        <span class="tooltip">Платежи</span>
      </li>
      <li v-if="(allAdministrators || allBuhgalters || onlyHeadsOfManagment)">
        <router-link to="/agents">
          <i class="bx bx-money"></i>
          <span class="links_name">Агенты</span>
        </router-link>
        <span class="tooltip">Агенты</span>
        <b-collapse id="collapse-4" v-model="visible">
          <ul class="child-block">
            <li class="child_item">
              <router-link to="/agents"
                >Агенты</router-link
              >
            </li>
            <li class="child_item" v-if="allAdministrators">
              <router-link to="/agent-corp-mail"
                >Корпоративные почты</router-link
              >
            </li>
            <li class="child_item" v-if="allAdministrators || allBuhgalters">
              <router-link to="/agent-settlements"
                >Взаиморасчеты с агентами</router-link
              >
            </li>
            <li class="child_item" v-if="allAdministrators || allBuhgalters">
              <router-link to="/agent-withdrawal-requests"
                >Заявки на вывод средств</router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/cold-clients"
                >Клиентская база</router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/useful-materials">
                Материалы
              </router-link>
            </li>
          </ul>
        </b-collapse>
      </li>
      <li v-if="onlyManagersOfManagment">
        <router-link to="/agents">
          <i class="bx bx-money"></i>
          <span class="links_name">Агенты</span>
        </router-link>
        <span class="tooltip">Агенты</span>
        <b-collapse id="collapse-4" v-model="visible">
          <ul class="child-block">
            <li class="child_item">
              <router-link to="/cold-clients"
                >Клиентская база</router-link
              >
            </li>
            <li class="child_item">
              <router-link to="/useful-materials">
                Материалы
              </router-link>
            </li>
          </ul>
        </b-collapse>
      </li>
      <li v-if="allAdministrators">
        <router-link to="/news">
          <i class="bx bx-news"></i>
          <span class="links_name">Новости</span>
        </router-link>
      </li>
      <li>
        <router-link to="/calculator">
          <i class="bx bx-calculator"></i>
          <span class="links_name">Калькулятор</span>
        </router-link>
        <span class="tooltip">Калькулятор</span>
      </li>
      <li>
        <router-link to="/companies">
          <i class="bx bx-building-house"></i>
          <span class="links_name">Компании</span>
        </router-link>
        <span class="tooltip">Компании</span>
      </li>
      <li v-if="onlyAdministrators">
        <router-link to="/references">
          <i class="bx bx-book-open"></i>
          <span class="links_name">Справочники</span>
        </router-link>
      </li>
      <li>
        <router-link to="/calendar">
          <i class="bx bx-calendar"></i>
          <span class="links_name">Календарь</span>
        </router-link>
      </li>
    </ul>
    <div class="tsoft-active-section">
      <span>{{ handlerActivePageName() }}</span>
    </div>
    <div class="tsoft-sidebar-button">
      <i class="bx bx-menu" id="btn" @click="handlerOpenOrCloseMenu"></i>
    </div>
    <div class="app-version" v-if="visible">
      <span class="version-text">Версия: {{ appVersion }}</span>
    </div>
  </div>
</template>

<script>
import { API_USERS_LISTS } from "../../constants";
import { mapGetters } from "vuex";

const SERVICES_ID_TO_NAMES = {
  22: "to",
  23: "teo",
  24: "sertifikaciya",
  25: "other",
  75: "pnk", 
  76: "svh", 
  77: "strahovanie"
};
const initialNotifications = () => ({
  orders: [],
  to: [],
  teo: [],
  sertifikaciya: [],
  other: [],
  by_creators: {},
  agents: [],
});

export default {
  data() {
    return {
      notificationsLocal: initialNotifications(),
      handlerSidebar: false,
      visible: false,
      internalUsers: [],
      agents: [],
      isOnlyForAccountant: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["currentUser", "isAuthenticated"]),

    notifications() {
      return this.$store.getters.NOTIFICATIONS;
    },

    appVersion() {
      return window.CLIENT_VERSION || '0.9.112';
    },

    canSeeServices() {
      return (
        !this.currentUser.role.includes("accountant") &&
        !this.currentUser.role.includes("head-accountant") &&
        !this.currentUser.role.includes("lead-observer")
      );
    },
    canSeeLogistic() {
      return (
        this.allHeadsOfManagment ||
        this.onlyLogisticManager ||
        this.allAdministrators
      );
    },

    canSeeOrders() {
      return !this.currentUser.role.includes("sales-manager");
    },

    canSeeFinance() {
      return !this.currentUser.role.includes("sales-manager");
    },

    canSeeRequests() {
      return (
        this.currentUser.role.includes("TO-head-manager") ||  // ВРЕМЕННОЕ РЕШЕНИЕ
        this.currentUser.role.includes("sales-manager") ||
        this.currentUser.role.includes("sales-head-manager") ||
        this.currentUser.role.includes("president") ||
        this.currentUser.role.includes("administrator")
      );
    },
    canSeeQuotationTO() {
      return (
        this.currentUser.role.includes("TO-manager") ||
        this.currentUser.role.includes("TO-head-manager") ||
        this.currentUser.role.includes("bsz-manager") ||
        this.currentUser.role.includes("president") ||
        this.currentUser.role.includes("administrator")
      );
    },
    canSeeQuotationLogistics() {
      return (
        this.currentUser.role.includes("logistics-manager") ||
        this.currentUser.role.includes("logistics-head-manager") ||
        this.currentUser.role.includes("logistics-multim-manager") ||
        this.currentUser.role.includes("logistics-multim-head-manager") ||
        this.currentUser.role.includes("president") ||
        this.currentUser.role.includes("administrator")
      );
    },

    onlyLogisticManager() {
      return this.currentUser.role.includes("logistics-manager") || this.currentUser.role.includes("logistics-multim-manager");
    },

    allHeadsOfManagment() {
      return (
        this.currentUser.role.includes("logistics-head-manager") ||
        this.currentUser.role.includes("sales-head-manager") ||
        this.currentUser.role.includes("logistics-multim-head-manager") ||
        this.currentUser.role.includes("TO-head-manager")
      );
    },

    onlyHeadsOfManagment() {
      return (
        this.currentUser.role.includes("TO-head-manager")
      );
    },
    
    onlyManagersOfManagment() {
      return (
        this.currentUser.role.includes("TO-manager")
        // this.currentUser.role.includes("sales-manager") ||
        // this.currentUser.role.includes("sales-head-manager")
      );
    },

    allBuhgalters() {
      return (
        this.currentUser.role.includes("president") ||
        this.currentUser.role.includes("administrator") ||
        this.currentUser.role.includes("accountant") ||
        this.currentUser.role.includes("head-accountant")
      );
    },
  
    specialBuhgalters() {
      return (
        this.currentUser.role.includes("administrator") ||
        this.currentUser.id === 11 || // Ольга Зуева
        this.currentUser.id === 12 || // Игорь Шустов
        this.currentUser.id === 17 || // Елена Кретова 
        this.currentUser.id === 18 || // Рената Курбаева
        this.currentUser.id === 73    // Александр Шеломцев
      );
    },

    canSeeOrderFinanceReport() {
      const allowedRoles = [
        "administrator",
        "president",
        "head-accountant",
        "sales-head-manager",
        "TO-head-manager",
        "logistics-head-manager",
        "logistics-multim-head-manager",
      ];
      return this.currentUser.role.some((role) => allowedRoles.includes(role));
    },

    allAdministrators() {
      return (
        this.currentUser.role.includes("president") ||
        this.currentUser.role.includes("administrator")
      );
    },

    onlyAdministrators() {
      return (
        this.currentUser.role.includes("administrator")
      );
    },
  },
  mounted() {
    this.onlyForAccountant();

    if (
      this.$store.state.userLocalSettings.interfaceSettings.sidebarMenu ==
      "open"
    ) {
      setTimeout(() => {
        this.handlerOpenOrCloseMenu();
      }, 500);
    }
  },
  watch: {
    notifications(newNotifications) {
      this.distributeNotifications(newNotifications);
    },

    visible(value) {
      this.$store.dispatch("userLocalSettings/SET_INTERFACE_SETTINGS", {
        name: "sidebarMenu",
        value: value ? "open" : "",
      });
    },
  },
  methods: {
    handlerOpenOrCloseMenu() {
      let sidebar = document.querySelector(".sidebar");
      let closeBtn = document.querySelector("#btn");
      let activeSection = document.querySelector(".tsoft-active-section");

      let menuBtnChange = () => {
        if (sidebar.classList.contains("open")) {
          this.visible = true;
          closeBtn.classList.replace("bx-menu", "bx-menu-alt-right");
        } else {
          this.visible = false;
          closeBtn.classList.replace("bx-menu-alt-right", "bx-menu");
        }
      };

      activeSection.classList.toggle("hide");
      sidebar.classList.toggle("open");

      menuBtnChange();
    },
    handlerActivePageName() {
      if (this.$route.meta.title) {
        return this.$route.meta.title;
      }

      if (this.$route.meta.services) {
        return this.$route.meta.services[this.$route.params.service_id];
      }

      if (this.$route.meta.invoices_type) {
        for (let typeInvoices in this.$route.params) {
          return this.$route.meta.invoices_type[
            this.$route.params[typeInvoices]
          ];
        }
      }

      for (let userId in this.internalUsers) {
        if (this.$route.params.user_id == this.internalUsers[userId].id) {
          return "Запросы: " + this.internalUsers[userId].name;
        }
      }

      // Проверяем, если это страница агентов
      if (this.$route.params.user_id === 'agents') {
        return "Запросы: Агенты";
      }
    },
    distributeNotifications(newNotifications = []) {
      this.notificationsLocal = initialNotifications();

      this.internalUsers.forEach((user, index) => {
        this.$set(this.notificationsLocal.by_creators, `${user.id}`, []);
      });

      // Создаем массив ID агентов для быстрой проверки
      const agentIds = this.agents.map(agent => agent.id);

      newNotifications.forEach((notify) => {
        try {
          if (notify.data && notify.data.parameters && notify.data.parameters.service_id) {
            this.notificationsLocal[
              SERVICES_ID_TO_NAMES[notify.data.parameters.service_id]
            ].push(notify);
          }
          if (notify.data && notify.data.parameters && notify.data.parameters.order_id) {
            this.notificationsLocal["orders"].push(notify);
          }
          if (
            notify.data.parameters &&
            notify.data.parameters.creator_user_id
          ) {
            let user_id = notify.data.parameters.creator_user_id;
            
            // Проверяем, является ли создатель агентом
            if (agentIds.includes(user_id)) {
              this.notificationsLocal.agents.push(notify);
            } else if (this.notificationsLocal.by_creators[user_id]) {
              this.notificationsLocal.by_creators[user_id].push(notify);
            }
          }
        } catch (error) {
          // console.error(error)
        }
      });
    },

    onlyForAccountant() {
      if (
        this.currentUser.role.includes("administrator") ||
        this.currentUser.role.includes("head-accountant") ||
        this.currentUser.role.includes("accountant")
      ) {
        this.isOnlyForAccountant = true;
        this.getAllFinanceUsers();
        return true;
      }
      return false;
    },

    getAllFinanceUsers() {
      api
        .call("get", `${API_USERS_LISTS}?list_type=for-accountants`)
        .then(({ data }) => {
          this.internalUsers = data.regular_users || [];
          this.agents = data.agents || [];
          this.$store.dispatch("GET_NOTIFICATIONS");
        });
    },
  },
};
</script>